import React, { Component } from "react";
import Fase from "../../components/results/Fase";
import StartNextFaseDialog from "../../components/results/StartNextFaseDialog";
import ReverseFaseDialog from "../../components/results/ReverseFaseDialog";
import PouleResults from "../../components/results/PouleResults";
import { getPouleScores } from "../../util/GetPouleScores";
import NextFasePoules from "../../components/results/NextFasePoules";
import MenuItem from "@material-ui/core/MenuItem";
import { languages } from "../../constants/languages";
import { groupBy } from "../../util/GroupBy";
import DefaultFases from "../../constants/DefaultFases";

class FaseContainer extends Component {
  state = {
    open: false,
    openBack: false,
    faseResults: {},
    nextFaseDivision: {},
    errorMessage: "",
    errorMessageReverse: "",
  };

  setFaseData = (props) => {
    // all fases
    let resultsPerFase = {};
    let poulesInThisDivision = props.poules.filter(
      (poule) => poule.division === props.division.id && poule.bracket === null
    );
    let poulesPerFase = groupBy(poulesInThisDivision, "fase");
    for (let f in poulesPerFase) {
      let poulesInFase = poulesPerFase[f].sort((a, b) => {
        if (a.indexNum > b.indexNum) {
          return 1;
        } else if (a.indexNum < b.indexNum) {
          return -1;
        } else {
          return a.num - b.num;
        }
      });
      if (resultsPerFase[f] === undefined) {
        resultsPerFase[f] = {};
      }
      poulesInFase.forEach((p) => {
        resultsPerFase[f][p.id] = getPouleScores(
          props.tournament,
          props.matches.filter((match) => match.poule === p.id),
          p
        ).filter((r) => {
          let poule = this.props.poulesByKey[p.id];
          let hide = false;
          if (poule["status" + r.teamKey]) {
            hide = true;
          }
          return !hide;
        });
      });
    }

    // current fase
    let faseResults = {};
    let nextFaseDivision = {};

    // show all poules that have a reference in next phase
    let referencedPoules = [];
    if (props.nextFase) {
      // TO DO: fix repeating code
      let nextPoules = props.poules
        .filter(
          (poule) =>
            poule.fase === Number(props.nextFase.id) &&
            poule.division === props.division.id &&
            (poule.bracket === null ||
              (poule.bracket &&
                !(props.bracketsByKey[poule.bracket] || {}).subBracketTo &&
                poule.bracketRound ===
                  (props.bracketsByKey[poule.bracket] || {}).size))
        )
        .sort((a, b) => {
          if (a.indexNum > b.indexNum) {
            return 1;
          } else if (a.indexNum < b.indexNum) {
            return -1;
          } else {
            return a.num - b.num;
          }
        })
        .map((p) => p.id);
      props.resultSpotsAll
        .filter((r) => nextPoules.indexOf(r["poule" + props.nextFase.id]) > -1)
        .forEach((r) => {
          if (referencedPoules.indexOf(r.fromPoule) === -1) {
            referencedPoules.push(r.fromPoule);
          }
        });
    }
    let poulesInThisFase = props.poules
      .filter(
        (poule) =>
          referencedPoules.indexOf(poule.id) !== -1 &&
          poule.division === props.division.id &&
          poule.bracket === null
      )
      .sort((a, b) => {
        if (a.indexNum > b.indexNum) {
          return 1;
        } else if (a.indexNum < b.indexNum) {
          return -1;
        } else {
          return a.num - b.num;
        }
      });
    poulesInThisFase.forEach((p) => {
      faseResults[p.id] = getPouleScores(
        props.tournament,
        props.matches.filter((match) => match.poule === p.id),
        p
      ).filter((r) => {
        let poule = this.props.poulesByKey[p.id];
        let hide = false;
        if (poule["status" + r.teamKey]) {
          hide = true;
        }
        return !hide;
      });
    });

    // next fase
    let poulesForNextFase = [];
    if (props.nextFase) {
      poulesForNextFase = props.poules
        .filter((poule) => {
          return (
            poule.fase === Number(props.nextFase.id) &&
            poule.division === props.division.id &&
            (poule.bracket === null ||
              (poule.bracket &&
                !(props.bracketsByKey[poule.bracket] || {}).subBracketTo &&
                poule.bracketRound ===
                  (props.bracketsByKey[poule.bracket] || {}).size))
          );
        })
        .sort((a, b) => {
          if (a.indexNum > b.indexNum) {
            return 1;
          } else if (a.indexNum < b.indexNum) {
            return -1;
          } else {
            return a.num - b.num;
          }
        })
        .map((p) => p.id);

      let resultSpotsToReplace = props.resultSpotsAll.filter(
        (r) => poulesForNextFase.indexOf(r["poule" + props.nextFase.id]) > -1
      );

      resultSpotsToReplace.forEach((r) => {
        let poule = r["poule" + props.nextFase.id];
        if (nextFaseDivision[poule] === undefined) {
          nextFaseDivision[poule] = {};
        }
        if (r.type === 0) {
          let fromPoule = r.fromPoule;
          let fromPouleObj = this.props.poulesByKey[fromPoule];
          let faseResultsForResultSpot = resultsPerFase[fromPouleObj.fase];
          let teamKey = ((faseResultsForResultSpot[r.fromPoule] || {})[
            r.rank
          ] || {})["teamKey"];

          let team = props.teams.filter(
            (t) =>
              t["poule" + r.fase] === fromPoule &&
              t["numInPoule" + r.fase] === Number(teamKey)
          )[0];
          nextFaseDivision[poule][r.id] = {
            teamId: team ? team.id : "",
            teamKey: teamKey,
            fromPoule: fromPoule,
            resultSpot: r,
          };
        } else if (r.type === 1) {
          let fromPouleObj = this.props.poulesByKey[r.fromPoule];
          let faseResultsForResultSpot = resultsPerFase[fromPouleObj.fase];
          const resultSpotsWithRank = props.resultSpotsAll
            .filter(
              (rs) =>
                rs.fase === r.fase &&
                rs.rank === r.rank &&
                rs.division === r.division
            )
            .sort((a, b) => {
              if (
                (props.poulesByKey[a.fromPoule] || {}).indexNum >
                (props.poulesByKey[b.fromPoule] || {}).indexNum
              ) {
                return 1;
              } else if (
                (props.poulesByKey[a.fromPoule] || {}).indexNum <
                (props.poulesByKey[b.fromPoule] || {}).indexNum
              ) {
                return -1;
              } else {
                return (
                  (props.poulesByKey[a.fromPoule] || {}).num -
                  (props.poulesByKey[b.fromPoule] || {}).num
                );
              }
            })
            .map((rs) => rs.id);
          const num = resultSpotsWithRank.indexOf(r.id);
          let resultsWithRank = [];
          for (let pouleResult in faseResultsForResultSpot) {
            if (faseResultsForResultSpot[pouleResult][r.rank]) {
              let resultsRank = faseResultsForResultSpot[pouleResult][r.rank];
              resultsRank["fromPouleForRank"] = pouleResult;
              resultsWithRank.push(resultsRank);
            }
          }
          resultsWithRank.sort((a, b) => {
            if (a.pouleScore > b.pouleScore) return -1;
            if (a.pouleScore < b.pouleScore) return 1;
            if (a.goals > b.goals) return -1;
            if (a.goals < b.goals) return 1;
            if (a.goalsFor > b.goalsFor) return -1;
            if (a.goalsFor < b.goalsFor) return 1;
            return 0;
          });
          // console.log(num, "resultsWithRank", resultsWithRank);
          let teamKey = (resultsWithRank[num] || {}).teamKey;
          let fromPoule = (resultsWithRank[num] || {}).fromPouleForRank;
          let team = props.teams.filter(
            (t) =>
              t["poule" + r.fase] === fromPoule &&
              t["numInPoule" + r.fase] === Number(teamKey)
          )[0];
          nextFaseDivision[poule][r.id] = {
            teamId: team ? team.id : "",
            teamKey: teamKey,
            fromPoule: fromPoule,
            resultSpot: r,
          };
        }
      });
    }
    // console.log("fase results", faseResults);
    // console.log("next fase division", nextFaseDivision);
    this.setState({
      faseResults: faseResults,
      nextFaseDivision: nextFaseDivision,
    });
  };

  UNSAFE_componentWillMount = () => {
    this.setFaseData(this.props);
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    this.setFaseData(nextProps);

    if (
      nextProps.fase.played === nextProps.fase.total &&
      nextProps.fase.total !== 0 &&
      nextProps.nextFase
    ) {
      const phaseObject = (this.props.division.fases || DefaultFases)[
        this.props.faseKey
      ];
      // Check if user has rights to manage phases
      const hasPhaseManagementRights =
        !this.props.tournamentAdmin ||
        (this.props.tournamentAdmin &&
          this.props.tournamentAdmin.managePhases === true);
      if (
        !phaseObject.startAlertShown &&
        nextProps.nextFase &&
        !nextProps.nextFase.started &&
        hasPhaseManagementRights
      ) {
        let toUpdate = this.props.division.fases || DefaultFases;
        toUpdate[this.props.faseKey]["startAlertShown"] = true;
        window.firebase
          .firestore()
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection("divisions")
          .doc(this.props.division.id)
          .update({ fases: toUpdate });
        this.setState({ open: !this.state.open });
      }
    }

    if (nextProps.fase.played !== nextProps.fase.total) {
      const phaseObject = (this.props.division.fases || DefaultFases)[
        this.props.faseKey
      ];
      if (phaseObject.startAlertShown) {
        let toUpdate = this.props.division.fases || DefaultFases;
        toUpdate[this.props.faseKey]["startAlertShown"] = false;
        window.firebase
          .firestore()
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection("divisions")
          .doc(this.props.division.id)
          .update({ fases: toUpdate });
      }
    }
  };

  toggleDialog = () => {
    this.setState({ open: !this.state.open });
  };

  toggleDialogBack = () => {
    this.setState({ openBack: !this.state.openBack, errorMessageReverse: "" });
  };

  handleDivisionChange = (e, poule, resultSpot) => {
    let nextFaseDivision = this.state.nextFaseDivision;
    nextFaseDivision[poule][resultSpot]["teamId"] = e.target.value;
    this.setState({ nextFaseDivision: nextFaseDivision });
  };

  handleStart = () => {
    const db = window.firebase.firestore();
    const teamsRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("teams");
    let batch = db.batch();
    const nextFaseDivision = this.state.nextFaseDivision;
    // check if no team is divided twice
    let dividedTeams = [];
    let errorMessage = "";
    for (let p in nextFaseDivision) {
      if (nextFaseDivision.hasOwnProperty(p)) {
        let resultSpots = nextFaseDivision[p];
        for (let r in resultSpots) {
          if (resultSpots.hasOwnProperty(r)) {
            let rs = resultSpots[r];
            if (rs.teamId) {
              if (dividedTeams.indexOf(rs.teamId) === -1) {
                dividedTeams.push(rs.teamId);
                let numInPoule =
                  rs.resultSpot["numInPoule" + this.props.nextFase.id];
                let toUpdate = {};
                toUpdate["numInPoule" + this.props.nextFase.id] = numInPoule;
                toUpdate["poule" + this.props.nextFase.id] = p;

                // check if opponent is bye
                let poule = this.props.poulesByKey[p] || {};
                let opponentIsBye =
                  poule["status" + (numInPoule === 0 ? "1" : "0")];
                if (opponentIsBye) {
                  // to next bracket round
                  let toPouleKeyName =
                    poule.fase +
                    "-" +
                    poule.bracketRound / 2 +
                    "-" +
                    poule.bracket;
                  let resultSpot =
                    this.props.resultSpotsAll.find(
                      (rs) =>
                        rs.fromPoule === p &&
                        rs.rank === 0 &&
                        rs.belongsToBracket === poule.bracket
                    ) || {};
                  let toPoule = resultSpot["poule" + this.props.nextFase.id];
                  let toNumInPoule =
                    resultSpot["numInPoule" + this.props.nextFase.id];
                  if (toPoule !== undefined && toNumInPoule !== undefined) {
                    toUpdate["poule" + toPouleKeyName] = toPoule;
                    toUpdate["numInPoule" + toPouleKeyName] = toNumInPoule;
                  }
                }
                batch.update(teamsRef.doc(rs.teamId), toUpdate);
              } else {
                errorMessage = languages.formatString(
                  languages.results.teamDoubleError,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                );
              }
            }
          }
        }
      }
    }
    if (errorMessage.length !== 0) {
      this.setState({
        errorMessage: errorMessage,
      });
    } else {
      let toUpdate = this.props.division.fases;
      toUpdate[this.props.nextFase.id]["started"] = true;
      batch.update(
        db
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection("divisions")
          .doc(this.props.division.id),
        { fases: toUpdate }
      );

      if (this.props.tournament.ia) {
        batch.set(db.collection("cacheUpdatesApp").doc(), {
          tournamentId: this.props.tournament[".key"],
          status: "pending",
          timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
        });
      }

      batch.commit();
      this.toggleDialog();
    }
  };

  handleReverse = () => {
    let faseMatches = this.props.matches.filter(
      (m) =>
        (this.props.poulesByKey[m.poule] || {}).division ===
          this.props.division.id &&
        (this.props.poulesByKey[m.poule] || {}).fase ===
          Number(this.props.nextFase.id)
    );

    let allMatchesEmpty = true;
    faseMatches.forEach((m) => {
      if (m.score1 !== null) {
        allMatchesEmpty = false;
      }
      let poule = this.props.poulesByKey[m.poule] || {};
      let scoreType =
        poule.scoreType ||
        (poule.bracket
          ? (this.props.bracketsByKey[poule.bracket] || {})["scoreType"]
          : false) ||
        ((this.props.tournament.scoringTypesPerDivisionPerPhase || {})[
          poule.division
        ] || {})[poule.fase] ||
        "default";
      let scoring =
        scoreType === "default"
          ? this.props.tournament
          : (this.props.tournament.scoringTypes || {})[scoreType] ||
            this.props.tournament;
      if (scoring.useSets === "1") {
        Object.keys(m.sets || {}).forEach((key) => {
          let set = m.sets[key];
          if (set.score1 || set.score2) {
            allMatchesEmpty = false;
          }
        });
      }
    });

    if (!allMatchesEmpty) {
      this.setState({
        errorMessageReverse: languages.results.matchesWithScoresError,
      });
    } else {
      let teams = this.props.teams.filter(
        (t) =>
          t["poule" + this.props.nextFase.id] &&
          t.division === this.props.division.id
      );
      const db = window.firebase.firestore();
      const teamsRef = db
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .collection("teams");
      let batch = db.batch();

      for (let t in teams) {
        let team = teams[t];
        let toUpdate = {};
        toUpdate["poule" + this.props.nextFase.id] = null;
        toUpdate["numInPoule" + this.props.nextFase.id] = null;
        Object.keys(this.props.bracketsByKey)
          .filter(
            (key) =>
              this.props.bracketsByKey[key].fase ===
              Number(this.props.nextFase.id)
          )
          .forEach((key) => {
            let bracket = this.props.bracketsByKey[key];
            let size = bracket.size;
            while (size / 2 > 1) {
              toUpdate[
                "poule" + this.props.nextFase.id + "-" + size / 2 + "-" + key
              ] = null;
              size = size / 2;
            }
          });
        batch.update(teamsRef.doc(team.id), toUpdate);
      }

      let toUpdate = this.props.division.fases;
      toUpdate[this.props.nextFase.id]["started"] = false;
      batch.update(
        db
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection("divisions")
          .doc(this.props.division.id),
        { fases: toUpdate }
      );
      this.toggleDialogBack();
      if (this.props.tournament.ia) {
        batch.set(db.collection("cacheUpdatesApp").doc(), {
          tournamentId: this.props.tournament[".key"],
          status: "pending",
          timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
        });
      }
      batch.commit();
    }
  };

  render() {
    let poulesInThisFaseResults = Object.keys(this.state.faseResults)
      .sort((a, b) => {
        if (
          this.props.poulesByKey[a].indexNum >
          this.props.poulesByKey[b].indexNum
        ) {
          return 1;
        } else if (
          this.props.poulesByKey[a].indexNum <
          this.props.poulesByKey[b].indexNum
        ) {
          return -1;
        } else {
          return this.props.poulesByKey[a].num - this.props.poulesByKey[b].num;
        }
      })
      .map((p) => {
        let poule = this.props.poulesByKey[p];
        poule["id"] = p;
        return (
          <PouleResults
            key={p}
            {...this.props}
            faseKeyPoule={poule.fase}
            poule={poule}
            pouleResults={this.state.faseResults[p]}
          />
        );
      });
    let nextFasePoules = (
      <NextFasePoules
        {...this.props}
        nextFaseDivision={this.state.nextFaseDivision}
        handleDivisionChange={this.handleDivisionChange}
        menuItems={this.props.teams
          .filter((t) => t.division === this.props.division.id)
          .map((team) => (
            <MenuItem key={team.id} value={team.id}>
              {team.gamertag || team.name}
            </MenuItem>
          ))}
      />
    );

    let enableStartPhase = true;
    if (this.props.nextFase) {
      this.props.poules
        .filter(
          (poule) =>
            poule.fase === Number(this.props.nextFase.id) &&
            poule.division === this.props.division.id &&
            poule.bracket === null
        )
        .concat(
          this.props.brackets.filter(
            (bracket) =>
              bracket.fase === Number(this.props.nextFase.id) &&
              bracket.division === this.props.division.id &&
              !bracket.subBracketTo
          )
        )
        .forEach((el) => {
          if (el.isBracket) {
            const bracketPoules = this.props.poules.filter(
              (p) =>
                p.bracket === el.id &&
                p.bracketRound === el.size &&
                !p.losersFinal
            );
            bracketPoules.forEach((p) => {
              for (let i = 0; i < p.pouleSize; i++) {
                let team = this.props.teams.filter(
                  (t) =>
                    t["poule" + this.props.nextFase.id] === p.id &&
                    t["numInPoule" + this.props.nextFase.id] === i
                )[0];
                if (!team) {
                  enableStartPhase = false;
                }
              }
            });
          } else {
            for (let i = 0; i < el.pouleSize; i++) {
              let team = this.props.teams.filter(
                (t) =>
                  t["poule" + this.props.nextFase.id] === el.id &&
                  t["numInPoule" + this.props.nextFase.id] === i
              )[0];
              if (!team) {
                enableStartPhase = false;
              }
            }
          }
        });
    } else {
      enableStartPhase = false;
    }

    return (
      <div>
        <StartNextFaseDialog
          {...this.props}
          open={this.state.open}
          toggleDialog={this.toggleDialog}
          poulesInThisFaseResults={poulesInThisFaseResults}
          nextFasePoules={nextFasePoules}
          handleStart={this.handleStart}
          errorMessage={this.state.errorMessage}
          submitDisabled={Object.keys(this.state.nextFaseDivision).length === 0}
          enableStartPhase={enableStartPhase}
        />
        <ReverseFaseDialog
          nextFase={this.props.nextFase}
          open={this.state.openBack}
          toggleDialog={this.toggleDialogBack}
          handleReverse={this.handleReverse}
          errorMessageReverse={this.state.errorMessageReverse}
          tournament={this.props.tournament}
        />
        <Fase
          {...this.props}
          toggleDialog={this.toggleDialog}
          toggleDialogBack={this.toggleDialogBack}
        />
      </div>
    );
  }
}

export default FaseContainer;
